import React from 'react';

import { initCarrotQuest, warn } from '../helpers';

/**
 * Поднимает виджет CarrotQuest под переданный ключ фонда и сообщает,
 * что API виджета готово принимать вызовы (очередь заглушки уже создана).
 *
 * @example
 * const isInitialized = useCarrotQuestInit(fund?.cq_api_key);
 */
export const useCarrotQuestInit = (id?: string | null) => {
  const [isInitialized, setIsInitialized] = React.useState(false);

  React.useEffect(() => {
    if (!id) {
      return;
    }

    try {
      initCarrotQuest({ id });
      setIsInitialized(true);
    } catch (error) {
      warn(`Initialization failed: ${error}`);
    }
  }, [id]);

  return isInitialized;
};
